/**
 * Centralized contact email addresses
 *
 * Use these constants throughout the application to ensure consistency
 * and easy updates when contact information changes.
 */
export const CONTACT_EMAILS = {
  /** Main support email for Bloom */
  SUPPORT: 'hello@getbloom.work',
  /** Ginione-specific support email */
  GINIONE_SUPPORT: 'hello@ginione.de',
} as const;

/**
 * Default contact email used in most places
 */
export const DEFAULT_GINIONE_CONTACT_EMAIL = CONTACT_EMAILS.GINIONE_SUPPORT;
export const DEFAULT_CONTACT_EMAIL = CONTACT_EMAILS.SUPPORT;
